export const authInputCls = "w-full bg-transparent border border-[#262421] px-4 py-3 mt-2 outline-none focus:border-[#C49A6C] transition-colors text-[#F2EBE1] text-sm";
export const authLabelCls = "text-xs text-[#8A857D]";
export const authBtnCls = "w-full bg-[#C49A6C] text-[#0B0A08] text-sm font-semibold py-4 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50";

export const AUTH_TEXT = {
  en: {
    forgot: "Forgot password?",
    forgotTitle: "Forgot password",
    forgotSub: "Enter the email you signed up with and we'll send you a link to choose a new password.",
    email: "Email",
    sendLink: "Send reset link",
    sent: "If an account exists for that email, a reset link is on its way. Check your inbox (and spam folder). The link expires in 1 hour.",
    backToLogin: "Back to login",
    resetTitle: "Choose a new password",
    newPassword: "New password (min. 8 characters)",
    confirmPassword: "Confirm new password",
    savePassword: "Save new password",
    doneTitle: "Password updated",
    doneSub: "Your password has been changed. Please log in with your new password.",
    goLogin: "Go to login",
    tooShort: "Password must be at least 8 characters.",
    mismatch: "Passwords do not match.",
    badLink: "This reset link is invalid or has expired. Please request a new one.",
    tooMany: "Too many attempts. Please wait a few minutes and try again.",
    genericError: "Something went wrong. Please try again.",
  },
  ar: {
    forgot: "نسيت كلمة المرور؟",
    forgotTitle: "نسيت كلمة المرور",
    forgotSub: "اكتب الإيميل اللي سجّلت فيه، وبنرسل لك رابط تختار منه كلمة مرور جديدة.",
    email: "البريد الإلكتروني",
    sendLink: "إرسال رابط إعادة الضبط",
    sent: "إذا كان فيه حساب بهذا الإيميل، بيوصلك رابط إعادة الضبط خلال لحظات. شيّك على البريد الوارد (والبريد المزعج). الرابط ينتهي خلال ساعة.",
    backToLogin: "الرجوع لتسجيل الدخول",
    resetTitle: "اختر كلمة مرور جديدة",
    newPassword: "كلمة المرور الجديدة (8 أحرف على الأقل)",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    savePassword: "حفظ كلمة المرور",
    doneTitle: "تم تغيير كلمة المرور",
    doneSub: "تم تغيير كلمة المرور بنجاح. سجّل دخولك بكلمة المرور الجديدة.",
    goLogin: "تسجيل الدخول",
    tooShort: "كلمة المرور لازم تكون 8 أحرف على الأقل.",
    mismatch: "كلمتا المرور غير متطابقتين.",
    badLink: "رابط إعادة الضبط غير صالح أو انتهت صلاحيته. اطلب رابط جديد.",
    tooMany: "محاولات كثيرة. انتظر شوي وحاول مرة ثانية.",
    genericError: "صار خطأ. حاول مرة ثانية.",
  },
};
